import { useEffect, useState } from "react";
import TextShortener from "../TextShortener";

const SubFormContent = ({username,dateofentry,monthofentry,yearofentry,message,men,women,youth,children,total_attend,tithe,offering,total,menAttend,youthAttend,womenAttend,
    childAttend,expensedetails,expenditure,remainingIncome,remarks,oncheckchanged,oneditclicked,onCopyAttendClicked}) => {

        const [showMendetails,setMendetails]=useState(false);
        const [showWomendetails,setWomendetails]=useState(false);
        const [showYouthdetails,setYouthdetails]=useState(false);
        const [showChildrendetails,setChildrendetails]=useState(false);
        const [showExpensesdetails,setExpdetails]=useState(false);
        const [editclicked,setclicked]=useState(false);
        const [copied,setCopied]=useState(false);
        const [showCopyStatus,setShowCopyStatus]=useState(false);
        

        const monthColors={
            "January": "#075E54",
            "December": "#0251EB",
            "February": "#ff4500",
            "March": "#FF3700B3",
            "April": "#6B014D",
            "May": "#1a1a1a",
            "June": "#29335c",
            "July": "#34B7F1",
            "August": "#25D366",
            "September": "#011F36",
            "October": "#696969",
            "November": "#000000"
        };

    const stageTotalincome=(e)=>{
        oncheckchanged(monthofentry,dateofentry,remainingIncome,e.target.checked);
    };
    const getdocdetails=()=>{
        oneditclicked(dateofentry,monthofentry,yearofentry,message,offering,tithe,men,women,youth,children,menAttend,womenAttend,
            youthAttend,childAttend,expenditure,expensedetails,remarks);
            setclicked(true);
    };
    const getAttendanceDetails = ()=>{
        onCopyAttendClicked(menAttend,womenAttend,youthAttend,childAttend);
            setCopied(true);
            setShowCopyStatus(true);
    };
    useEffect(()=>{
        let timeid
        if(copied){
          timeid = setTimeout(() => {
             setCopied(false);
             setShowCopyStatus(false);
            },800);
        }
        return()=>{
            if(timeid){
                clearTimeout(timeid);
            }
        }
    
    },[copied]);


    return ( 
        <div className="subformcontent flex-column1" key={dateofentry} style={{backgroundColor:monthColors[monthofentry]}}>
            <h2>dN: {monthofentry},{yearofentry}</h2>
            <h4>submitted on: {dateofentry}</h4>
            <h4>submitted by: {username}</h4>
            <h4>Message Watched: {message}</h4> <br/>

            <div className="flex-row2" style={{width:"100%",gap:"10px"}}>
            <h3 style={{borderBottom:"2px solid white"}}>
                Attendance 
            </h3> 

            <div className="copytab" onMouseEnter={()=>setShowCopyStatus(true)} onMouseLeave={()=>setShowCopyStatus(false)} style={{position:"relative"}}>
                {
                    showCopyStatus && 
                    <div className="copystatus"> 
                    <p>{copied ? 'Copied':'Copy'}</p> 
                    </div>
                }
               
                <svg
                    onClick={()=>getAttendanceDetails()}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="2em"
                    width="2em">
                    <path d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z" />
                    <path d="M6 12h6v2H6zm0 4h6v2H6z" />
                </svg>
            </div>
       

            </div>
     

            <div className="flex-row2" onClick={()=>setMendetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Men: {men}</h4>
            <svg            
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showMendetails && 
                <div className="detaillist">
                    <pre>{menAttend}</pre>
                </div>           
            }
            </div>
            
            <div className="flex-row2" onClick={()=>setWomendetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Women: {women}</h4>
            <svg
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showWomendetails && 
                <div className="detaillist">
                    <pre>{womenAttend}</pre>
                </div>           
            }
            </div>

            <div className="flex-row2" onClick={()=>setYouthdetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Youth: {youth}</h4>
            <svg
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showYouthdetails && 
                <div className="detaillist">
                    <pre>{youthAttend}</pre>
                </div>           
            }
            </div>
           
            <div className="flex-row2" onClick={()=>setChildrendetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
            <h4>Children: {children}</h4>
            <svg
              cursor="pointer"
              viewBox="0 0 24 24"
              fill="white"
              height="2em"
              width="2em">
              <path fill="none" d="M0 0h24v24H0V0z" />
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>

            {showChildrendetails && 
                <div className="detaillist">
                    <pre>{childAttend}</pre>
                </div>           
            }
            </div>
            
            <h4>Total Attendees: {total_attend}</h4> <br/>

            <h3 style={{borderBottom:"2px solid white"}}>Finance</h3>
            <h4>Tithe: {parseFloat(tithe).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}</h4>
            <h4>Offering: {parseFloat(offering).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h4>
            <h4>Total Income: {parseFloat(total).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h4>

            <div className="flex-row2" onClick={()=>setExpdetails(prev => !prev)} style={{position:"relative",cursor:"pointer"}}>
                    <h4>Expenses: {expenditure ? parseFloat(expenditure).toLocaleString('en-US',{
                        style:'currency',currency: 'GHS'
                    }) : "GHS 0" }
                    </h4>

                    <svg
                    viewBox="0 0 24 24"
                    fill="white"
                    height="2em"
                    width="2em">
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>

                    {showExpensesdetails && 
                        <div className="detaillist">
                            <pre>{expensedetails && expensedetails}</pre>
                        </div>           
                    }
            </div>
          
            <h4>Net Income: {remainingIncome && parseFloat(remainingIncome).toLocaleString('en-US',{
                style:'currency',currency: 'GHS'
            })}
            </h4> <br/>

            <h4>Remarks</h4>
            <div className="remarkdiv">
            {remarks && <TextShortener fullText={remarks} words={12}/>}
            </div> 
            <br/>
            
            <div className="collatecheckbox">
            <input id="collatetotal" type="checkbox" onChange={stageTotalincome}/>
            </div>

            <div className={`editreportdoc ${editclicked ? 'onedit':'noedit'}`} onClick={()=>getdocdetails()}>
                <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                height="1.3em"
                width="1.3em">
                <path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3l1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z" />
                </svg>
            </div>
          
        </div>
     );
}
export default SubFormContent;